import(/* webpackMode: "eager" */ "/Users/wyattsmith/dev/ssd/homeschool/apps/app/src/app/global-error.tsx");
